module.exports = __webpack_public_path__ + "img/DSC04035.2baae8d4.jpg";